export const contentImageTag = ({ images }) => {
  const content = [];
  let breakPage = false;

  if (images?.length > 0) {
    images.forEach((image, index) => {
      const headlineLevel = breakPage ? 1 : 0;

      if (index % 2 !== 0) {
        breakPage = true;
      } else {
        breakPage = false;
      }

      content.push({
        headlineLevel,
        image,
        width: 300,
        margin: [108, 0, 0, 16]
      });
    });
  }

  return {
    content,
    pageBreakBefore(currentNode) {
      return currentNode.headlineLevel === 1;
    }
  };
};
